import React from 'react';
import styled from 'astroturf/react'
import { Popover, PopoverMode, PopoverProps } from 'js/design_system/Popover';
import _Container from "Tooltip-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/new_tooltip/Tooltip.tsx?styleId=Container";
import _containerStyles from "Tooltip-containerStyles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/new_tooltip/Tooltip.tsx?styleId=containerStyles";
import _TooltipContainer from "Tooltip-TooltipContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/new_tooltip/Tooltip.tsx?styleId=TooltipContainer";
import _Nubbin from "Tooltip-Nubbin.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/new_tooltip/Tooltip.tsx?styleId=Nubbin";
import _nubbinStyles from "Tooltip-nubbinStyles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/new_tooltip/Tooltip.tsx?styleId=nubbinStyles";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const containerStyles = _containerStyles;

const TooltipContainer = /*#__PURE__*/styled("div", null, {
  displayName: "TooltipContainer",
  styles: _TooltipContainer
});

const Nubbin = /*#__PURE__*/styled("div", null, {
  displayName: "Nubbin",
  styles: _Nubbin
});

const nubbinStyles = _nubbinStyles;

/**
 * A basic tooltip component with Academia styling. This component uses
 * {@link Popover} as its parent, adding some additional styling.
 *
 * Props:
 * - `placement`: Controls the placement of the tooltip relative to the activator.
 *                Choose between 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'bottom-start' | 'left-start' | 'right-start' | 'top-end' | 'bottom-end' | 'left-end' | 'right-end'
 * - `offset`: Controls the offset of the tooltip relative to the activator.
 * - `closeOnClick`: Controls whether the tooltip should close when the activator is clicked.
 * - `popoverRef`: A ref for the popover.
 * - `render`: A function that returns the tooltip content.
 * - `children`: The activator element.
 * - `mode`: Controls the Popover mode of the tooltip.
 *           Choose between 'click' | 'hover' | 'any'
 * - `tooltipColor`: Optional color for the tooltip and nubbin.
 * - `tooltipTextColor`: Optional color for the tooltip text.
 *
 * ## Basic Usage
 *
 * @example
 *
 * ```tsx
 * import { Tooltip } from 'js/design_system/Tooltip';
 *
 * <Tooltip
 *   render={() => <p>I'm the tooltip content!</p>}
 * >
 *   <p>Click me to activate!</p>
 * </Tooltip>
 * ```
 */
export const Tooltip: React.FC<
  PopoverProps & { tooltipColor?: string; tooltipTextColor?: string }
> = ({
  mode = PopoverMode.Hover,
  placement = 'top',
  offset = 4,
  closeOnClick = false,
  popoverRef,
  render,
  children,
  tooltipColor,
  tooltipTextColor,
  ...props
}) => {
  const tooltipStyle = {} as React.CSSProperties & {
    '--tooltip-color'?: string;
    '--tooltip-text-color'?: string;
  };
  if (tooltipColor) {
    tooltipStyle['--tooltip-color'] = tooltipColor;
  }
  if (tooltipTextColor) {
    tooltipStyle['--tooltip-text-color'] = tooltipTextColor;
  }

  return (
    <Popover
      mode={mode}
      placement={placement}
      offset={offset}
      closeOnClick={closeOnClick}
      render={() => {
        return (
          <Container
            className={containerStyles[placement]}
            style={tooltipStyle}
          >
            <TooltipContainer ref={popoverRef}>{render()}</TooltipContainer>
            <Nubbin className={nubbinStyles[placement]} />
          </Container>
        );
      }}
      {...props}
    >
      {children}
    </Popover>
  );
};
